import { styled } from '@mui/material/styles';

export const StyledTableContainer = styled('div')`
  & .MuiTable-root {
    min-width: 1100px;
  }
`;
